<template>
  <div class="wrap_">
    <img
      class="img_"
      v-for="(item, index) in list"
      :key="index"
      :src="item.img"
      :alt="item.title"
      @click="goconsult(item.url)"
    />
  </div>
</template>

<script>
const list = [
  {
    url: 'tel:400-880-8820',
    img: require('../../assets/image/common/phone.webp'),
    title: '电话'
  },
  {
    url: 'https://mdl.s2.udesk.cn/im_client/?web_plugin_id=22884',
    img: require('../../assets/image/common/kefu_text.png'),
    title: '客服'
  }
]
export default {
  data() {
    return {
      list: Object.seal(list)
    }
  },
  methods: {
    goconsult(url) {
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap_ {
  position: fixed;
  bottom: 100px;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .img_ {
    height: 38px;
    width: 38px;
    margin-top: 5px;
  }
}
</style>
